/* eslint-disable max-len */
import React from 'react';
import { Button, Dialogs, Flex, Pane } from '@leverege/ui-elements';
import { Toolbar, TitleBar } from '@leverege/ui-plugin';
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import StackOverlay from "../../screens/main/actions/StackOverlay.js";
import ToolbarFactory from "../../screens/main/actions/ToolbarFactory.js";
import useStack from "../../screens/main/actions/useStack.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.layout.MobileLayoutSelector');
function Root({
  stack,
  context
}) {
  const {
    client,
    onClose
  } = context;
  const matchContext = {
    client,
    use: 'mobileLayoutActionBar'
  };
  const factory = new ToolbarFactory({
    variant: 'mobileOptBar|mobileNavBar',
    vertical: true,
    stack,
    matchContext
  });
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "col",
    children: [/*#__PURE__*/_jsx(TitleBar, {
      variant: "mobileOptNavTitle",
      title: t('title'),
      children: /*#__PURE__*/_jsx(Button, {
        variant: "mobileNavClose",
        icon: Config.get('Main', 'closeIcon', 'https://molten-ui-assets.storage.googleapis.com/close.svg'),
        onClick: onClose
      })
    }), !stack.isEmpty() && /*#__PURE__*/_jsx(TitleBar, {
      variant: "mobileNavTitle",
      children: /*#__PURE__*/_jsx(Button, {
        variant: "mobileNavBack",
        onClick: stack.pop,
        children: t('back')
      })
    }), /*#__PURE__*/_jsx(Toolbar, {
      factory: factory,
      vertical: true,
      variant: "mobileOptBar|mobileNavBar",
      matchContext: matchContext,
      context: context
    })]
  });
}
function showOverlay(cxt) {
  Dialogs.show({
    component: Overlay,
    props: {
      context: cxt
    },
    id: 'mobileItemScreenNavActions'
  });
}
export default function MobileLayoutSelector({
  context
}) {
  return /*#__PURE__*/_jsx(Button, {
    variant: "layoutSelector",
    icon: Config.get('LayoutSelector', 'dashboardIcon', 'https://molten-ui-assets.storage.googleapis.com/dashboard.svg'),
    onClick: () => showOverlay(context)
  });
}
function Overlay(props) {
  const {
    show,
    onClose,
    context
  } = props;
  const stack = useStack();
  const renderer = stack => {
    return /*#__PURE__*/_jsx(Pane, {
      variant: "mobileOptNav",
      children: /*#__PURE__*/_jsx(Root, {
        stack: stack,
        context: {
          ...context,
          show,
          onClose
        }
      })
    });
  };
  return /*#__PURE__*/_jsx(StackOverlay, {
    mode: "single",
    stack: stack,
    renderer: renderer,
    show: show,
    onClose: onClose,
    position: "bottom",
    animation: "slideFromBottom"
  });
}